import React from 'react';
import { connect } from 'react-redux';
import { trackNow } from 'shared/models/analytic';
import { trackInfo, defaultIngredientOption } from 'shared/models/product';
import { getProduct } from 'shared/models/api';
import { addCart, addSeveral, showCart } from 'components/cart/actions';
import { ProductGridItem } from 'scy/ProductGrid';

function Item({
  product,
  trackCategory,
  isCheckout,
  includeItemProps,
  className,
  raiseOnHover,
  address,
  cartOpen,
  addCart,
  addSeveral,
  showCart
}) {
  function track() {
    trackNow('Product Clicked', trackInfo({ ...product, trackCategory }));
  }

  function add() {
    if (product.recipe) {
      addCollection();
    } else {
      addCart(product, 1, { checkout: isCheckout });
      setTimeout(showCart, 500);
    }
  }

  function addCollection() {
    getProduct(product.sku_id).then(product => {
      const ingredients = product.ingredients || [];
      if (ingredients.length) {
        const defaultProducts = ingredients
          .map(defaultIngredientOption)
          .filter(p => !!p.price);
        if (defaultProducts.length) {
          addSeveral(defaultProducts, 1, { checkout: isCheckout });
        }
      } else {
        addCart(product, 1, { checkout: isCheckout });
      }
      setTimeout(showCart, 500);
    });
  }

  if (!address || product.soldout) product.price = 0;

  const url = product.url;
  const linkProps = {
    to: url && url.indexOf('/') === 0 ? url : '/' + url,
    onClick: track,
    itemProp: 'url'
  };

  return (
    <ProductGridItem
      product={product}
      includeItemProps={includeItemProps}
      raiseOnHover={raiseOnHover}
      lazyLoad={!cartOpen}
      onButtonClick={add}
      linkProps={linkProps}
      className={className}
    />
  );
}

const ConnectedItem = connect(
  state => ({
    address: state.address.lat ? state.address : null,
    cartOpen: state.cart.show
  }),
  { addCart, addSeveral, showCart }
)(Item);

export default ConnectedItem;
